// extracted by mini-css-extract-plugin
export default {"content":"Content_content__vOne-","line":"Content_line__G09i3"};